// ✅ src/data/teamData.js

import rajeev from "../assets/team/rajeev.png";
import adv from "../assets/team/adv.jpg";
import deepak from "../assets/team/deepak.png";
import shefali from "../assets/team/shefali.png";
import ashish from "../assets/team/ashish.png";
import anil from "../assets/team/anil.png";
import rohit from "../assets/team/rohit.png";

import noimg from "../assets/team/rohit.png";

export const leaders = [
  {
    id: 1,
    name: "Rajeev Chhikara",
    role: "Board Chairman",
    image: rajeev,
    linkedin: "https://www.linkedin.com/in/rajeevchhikara/",
 
description: "Founder , Managing Director",
 },
  {
    id: 2,
    name: "A D Vashishta",
    role: "Board Member",
    image: adv,
    linkedin: "https://www.linkedin.com/in/advashishta/",
 
description: "Growth Partner, key strategies",
 },
  {
    id: 3,
    name: "Open",
    role: "Board Member",
    image: noimg,
    linkedin: "#",
description: "",
  },
];

export const advisoryBoard = [
  {
    id: 1,
    name: "Open",
    role: "Strategic Advisor",
    image: anil,
    linkedin: "#",
description: "",
  },
  {
    id: 2,
    name: "Open",
    role: "Technical Advisor",
    image: rohit,
    linkedin: "#",
description: "",
  },
  {
    id: 3,
    name: "Open",
    role: "Financial Advisor",
    image: rohit,
    linkedin: "#",
description: "",
  },
  {
    id: 4,
    name: "Open",
    role: "Investment Advisor",
    image: rohit,
    linkedin: "#",
description: "",

  },
];



export const consultantsBoard = [
 {
    id: 1,
    name: "Open",
    role: "Consultant",
    image: anil,
    linkedin: "#",
    description: "Provide sector-specific insights for startups and growth-stage companies.",
  },
   {
    id: 2,
    name: "Open",
    role: "Consultant",
    image: anil,
    linkedin: "#",
    description: "Legal & Compliance Advisors: Ensure regulatory adherence and safeguard investor interests.",
  },
   {
    id: 3,
    name: "Open",
    role: "Consultant",
    image: anil,
    linkedin: "#",
    description: "Financial Analysts: Support valuation, risk assessment, and market intelligence.",
  },
];


export const executiveBoard = [
  {
    id: 1,
    name: "Open",
    role: "Chief Executive Officer (CEO)",
    image: anil,
    linkedin: "#",
    description: "Leads overall strategy, investor relations, and portfolio growth.",
  },
  {
    id: 2,
    name: "Open",
    role: "Chief Investment Officer (CIO)",
    image: rohit,
    linkedin: "#",
    description: "Oversees capital allocation, portfolio diversification, and exit planning.",
  },
  {
    id: 3,
    name: "Open",
    role: "Chief Financial Officer (CFO)",
    image: rohit,
    linkedin: "#",
    description: "Manages financial structuring, reporting, and compliance.",
  },
  {
    id: 4,
    name: "Open",
    role: "Chief Operating Officer (COO)",
    image: rohit,
    linkedin: "#",
    description: "Ensures operational excellence across portfolio companies",
  },
];


